export function getActivityNameForUsagePlaces(activityName: string, usagePlaces: string) {
  if (activityName.length > 16) {
    return (usagePlaces += `__${activityName.slice(0, 15)}...`)
  }
  if (activityName.length <= 16) {
    return (usagePlaces += `__${activityName}`)
  }
}
